import { render, staticRenderFns } from "./DuplicateDeliverableDetailModal.vue?vue&type=template&id=4a6731f8&"
import script from "./DuplicateDeliverableDetailModal.vue?vue&type=script&lang=js&"
export * from "./DuplicateDeliverableDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./DuplicateDeliverableDetailModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports